import React, { Component } from "react";
import _ from 'lodash';
import { withStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import {
  Grid,
  Hidden,
  WithStyles,
  createStyles,
  Checkbox,
  FormControlLabel,
} from "@material-ui/core";
import { FEEDBACK_STATUS, FEEDBACK_STATUS_TEXTS, FEEDBACK_VALIDATOR_ACTIONS, NEW_FEEDBACK_TIME_TO_SHOW, SECTIONS } from "../../helper/contentValidation";
import { dateService } from "../../../common";
import { getPropertyValue } from '../../../../utils';
import { titleCase } from '../../../../constants/comman';
import cx from 'classnames';
import ViewRejectionReasonModal from "../ContentRating/ViewRejectionReasonModal";

const styles = (theme: Theme) => createStyles({
  feedbackSection: {
    paddingBottom: '145px',
    '& .feedbackContent': {
      '& .feedbackEmptyFilters': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        height: 'calc(100vh - 25rem)',
        textAlign: 'center',
        padding: '10px 34px',
        '& p': {
          fontSize: '14px',
          fontWeight: 400,
          lineHeight: '140%',
          color: '#666666',
          margin: '0',
        },
        '& h4': {
          fontSize: '18px',
          fontWeight: 400,
          lineHeight: '140%',
          color: '#333333',
          margin: '20px 0 5px 0',
        },
      },
      '& .feedbackEmpty': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        height: 'calc(100vh - 14.875rem)',
        textAlign: 'center',
        padding: '10px 34px',
        '& p': {
          fontSize: '20px',
          fontWeight: 400,
          lineHeight: '140%',
          color: '#666666',
          margin: '0 auto 15px',
        },
        '& .btnAddFeedback': {
          minWidth: '122px',
          height: '36px',
          padding: '5px 13px',
          textAlign: 'center',
          backgroundColor: '#1D7DEA',
          borderRadius: '4px',
          border: 'none',
          fontSize: '14px',
          fontWeight: 400,
          lineHeight: '135%',
          color: '#ffffff',
          cursor: 'pointer',
        },
        '&.hide': {
          display: 'none',
        }
      },
      '& .feedbackListing': {
        height: '100%',
        overflowY: 'auto',
        marginTop: '15px',
        '&::-webkit-scrollbar': {
          width: '4px',
        },
        '&::-webkit-scrollbar-track': {
          backgroundColor: '#b0b0b0',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#8c8c8c',
        },
        '&.hide': {
          display: 'none',
        },
        '& ul': {
          listStyle: 'none',
          padding: '0',
          margin: 0,
        },
        '& ul li': {
          padding: '15px 0',
          alignItems: 'center',
          borderBottom: '1px solid #DFDFDF',
          cursor: 'pointer',
          '&:first-child': {
            paddingTop: '0',
          },
          '&:last-child': {
            borderBottom: 'none',
          },
          '& .counter': {
            width: '34px',
            minWidth: '34px',
            height: '34px',
            borderRadius: '50%',
            backgroundColor: '#CE9AF6',
            fontSize: '16px',
            fontWeight: 400,
            color: '#ffffff',
            display: 'inline-flex',
            alignItems: 'center',
            alignSelf: 'center',
            justifyContent: 'center',
          },
          '& .contentBox': {
            padding: '0 12px',
            whiteSpace: 'nowrap',
            width: '100%',
            overflow: 'hidden',
            '& h6': {
              color: '#333333',
              margin: '0',
              fontSize: '18px',
              fontWeight: 400,
              lineHeight: '133%',
              textOverflow: 'ellipsis',
              overflow: 'hidden',
              width: '100%',
              whiteSpace: 'nowrap',
            },
            '& p': {
              fontSize: '16px',
              fontWeight: 400,
              lineHeight : '138%',
              color: '#666666',
              margin: 0,
              textOverflow: 'ellipsis',
              overflow: 'hidden',
              width: '100%',
              whiteSpace: 'nowrap',
            },
            '& span': {
              fontSize: '14px',
              fontWeight: 400,
              color: '#1D7DEA',
              lineHeight: 1.193,
              margin: 0,
              textOverflow: 'ellipsis',
              overflow: 'hidden',
              width: '100%',
              whiteSpace: 'nowrap',
            }

          },
          '& .statusBtn': {
            marginLeft: 'auto',
            border: '1px solid',
            borderRadius: '50px',
            fontSize: '14px',
            fontWeight: 400,
            lineHeight: '136%',
            padding: '3px 10px',
            whiteSpace: 'nowrap',
            textTransform: 'capitalize',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            alignSelf: 'center',
            '&.resolved': {
              borderColor: '#30BE76',
              color: '#30BE76',
            },
            '&.open': {
              borderColor: '#FFBD27',
              color: '#FFBD27',
            },
            '&.challenged': {
              borderColor: '#1D7DEA',
              color: '#1D7DEA',
            }
          }
        },
        '& .addFeedbackButton': {
          textAlign: 'center',
          margin: '20px auto',
          '& .addfeedbackBtn': {
            border: '1px solid #1D7DEA',
            borderRadius: '4px',
            fontSize: '14px',
            fontWeight: 400,
            lineHeight: '135%',
            color: '#1D7DEA',
            padding: '8px 13px',
            cursor: 'pointer',
            backgroundColor: '#ffffff',
          }
        }
      }
    }
  },
  filterWrapper: {
    margin: '-1px -20px 0',
    padding: '10px 20px',
    borderTop: '1px solid #DFDFDF',
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    borderBottom: '1px solid #DFDFDF',
    backgroundColor: '#F9F9F9',
    '&.rightAlign': {
      marginRight: 0,  
    },
    '& .filterPanel': {
      position: 'absolute',
      top: 38,
      right: 19,
      display: "flex",
      flexDirection: "column",
      background: "white",
      zIndex: 99,
      boxShadow: "0px 4px 15px 0px #0000001A",
      padding: 10,
      borderRadius: 2,
      border: "1px solid #E6E6E6",
      width: 240,
      "&::before": {
        content: "''",
        position: "absolute",
        width:0,
        height:0,
        borderStyle: "solid",
        borderWidth: "0 10px 10px",
        borderColor: "#e6e6e6 transparent",
        top:-9,
        right:23,
      },
      "&::after": {
        content: "''",
        position: "absolute",
        width:0,
        height:0,
        borderStyle: "solid",
        borderWidth: "0 10px 10px",
        borderColor: "#fff transparent",
        top:-7,
        right:23,
      }
    }
  },
  filterButton: {
    padding: "2px 10px",
    borderRadius: 30,
    border: "1px solid #E6E6E6",
    boxShadow: '0px 4px 10px 0px rgba(0, 0, 0, 0.05)',
    gap: "5px",
    fontSize: 14,
    fontWeight: 400,
    color: "#666666",
    background: "#FFFFFF",
    cursor: "pointer",
    minWidth: '89px',
    height: '36px',
    '& img': {
      verticalAlign: "-2px",
      marginRight: 5,
    }
  },
  checkBoxElement: {
		padding: '0px 7px',
		top: 0,
		width: 20,
		height: 20,
		'-moz-appearance': 'none',
		opacity: 1,
		color: 'rgb(204, 204, 204)',
		border: '1px solid #B2B2B2',
		borderRadius: 4,
		margin: '-4px 14px 0px 16px',
		'& svg': {
			fontSize: '1.5rem',
			fontFamily: '"Nunito", sans-serif',
			fill: '#979797',
			opacity: 0
		},
    '& span:nth-child(1)': {
      width: 24,
      zIndex: 9
    }
	},
  checkedCheckbox: {
		backgroundColor: '#1d7dea!important',
		border: '1px solid #1d7dea !important',
		borderRadius: 2,
		color: '#99a1a7',
		'&::before': {
			content: "''",
			fontSize: 14,
			position: 'absolute',
			top: 1,
			left: 6,
			width: 4,
			height: 10,
			border: 'solid #fff',
			borderWidth: '0 2px 2px 0',
			transform: 'rotate(45deg)'
		},
		'&:hover': {
			backgroundColor: '#1d7dea'
		}
	},
  primaryColor: {
		color: 'rgb(29 125 234)'
	},
  checkboxLabel: {
		fontSize: 18,
		color: '#363636',
	},
	formControlLabel: {
    '&:not(:last-child)': {
      marginBottom: 6,
    }
	},
  rejectionReasonsSection: {
    top: '0',
    left: '0',
    width: '100%',
    margin: '10px auto 0',
    display: 'flex',
    padding: '0.75rem 1.25rem',
    position: 'relative',
    alignItems: 'center',
    borderRadius: '8px',
    justifyContent: 'space-between',
    backgroundColor: '#1D7DEA0D',
    '& .icon-container': {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '5px',
    },
    '&. title': {
      fontSize: '0.75rem',
      fontWeight: 500,
      lineHeight: '138%',
      color: '#333333',
      width: 'calc(100% - 3.13rem)',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
    },
    '& .view-btn': {
      fontSize: '0.88rem',
      fontWeight: 600,
      lineHeight: '136%',
      color: '#1D7DEA',
      width: '3.13rem',
      textTransform: 'capitalize',
      cursor: 'pointer',
      textAlign: 'right',
    }
  },
  feedbackContainer: {
    width: 'calc(100% - 85px)',
    '& span': {
      fontSize: '12px',
      fontWeight: 400,
      lineHeight: '133%',
      color: '#333333',
    },
  },
  collapseAllbtn: {
    color: '#1D7DEA',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '136%',
    cursor: 'pointer',
  },
  'seperator': {
    width: '4px',
    height: '4px',
    borderRadius: '50%',
    backgroundColor: '#D9D9D9',
    margin: '0 5px',
    display: 'inline-block',
    verticalAlign: 'middle',
  },
  repliesSection: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    backgroundColor: '#F9F9F9',
    padding: '10px 14px 10px 10px',
    marginTop: '10px',
    '& .hideReplylabel': {
      fontSize: '0.875rem',
      fontWeight: 400,
      lineHeight: '1.193',
      color: '#1D7DEA',
      cursor: 'pointer',
      marginLeft: '3.25rem',
      marginTop: '0.5rem',
    }
  },
  replyContainer: {
    margin: '0 0 0 22px',
    padding: '5px 0',
    position: 'relative',
    borderBottom: 'none',
    borderLeft: '1px solid #EDEDED',
    width: 'calc(100% - 22px)',
    '& .user-name': {
      width: '24px',
      height: '24px',
      border: '1px solid #E6E6E6',
      display: 'inline-flex',
      minWidth: '24px',
      fontSize: '14px',
      alignItems: 'center',
      fontWeight: 400,
      borderRadius: '50%',
      justifyContent: 'center',
      position: 'absolute',
      left: '-12px',
      top: '50%',
      transform: 'translateY(-50%)',
      '&.authors': {
        backgroundColor: '#EFF9D9',
        color: '#30BE76',
      },
      '&.validators': {
        backgroundColor: '#F4F8FE',
        color: '#1D7DEA',
      }
    },
    '& .reply-container-inner': {
      padding: '0 0 0 24px',
      '& p': {
        fontSize: '14px',
        fontWeight: 400,
        color: '#666666',
        lineHeight: '19px',
        padding: '5px 0',
        margin: '0',
        display: 'flex',
        alignItems: 'center',
      },
      '& b': {
        fontSize: '16px',
        fontWeight: 400,
        lineHeight: '22px',
        color: '#333333',
        display: 'block',
        padding: '0 0 5px',
        width: '100%',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
      },
      '& .seperator': {
        width: '4px',
        height: '4px',
        borderRadius: '50%',
        backgroundColor: '#D9D9D9',
        margin: '0 5px',
      },
    },
  },
  header: {
    display: 'flex',
    width: '100%',
  },
  headerPaddingBottom: {
    position: 'relative',
  }
});

interface FeedbackSidebarProps extends WithStyles<typeof styles> {
  validationFeedbacks: any;
  createNewValidationFeedback: Function;
  allowFeedbacks: boolean;
  selectedQuestionRef: any;
  contentType: any,
  validationEditHistory?: any;
  fromContentCreate?:boolean;
}

interface FeedbackSidebarStates {
  isFilterOpen: boolean;
  selectedFeedbackFilters: string[];
  isViewRejectionReasonOpen: boolean;
  rejectionReasonsToShow: any[];
  isAllRepliesExpanded: boolean;
}
class FeedbackSidebar extends Component<
  FeedbackSidebarProps,
  FeedbackSidebarStates
> {
  dropdownPanelRef: any;
  constructor(props: FeedbackSidebarProps) {
    super(props);
    this.state = {
      isFilterOpen: false,
      selectedFeedbackFilters: Object.values(FEEDBACK_STATUS),
      isViewRejectionReasonOpen: false,
      rejectionReasonsToShow: [],
      isAllRepliesExpanded: false,
    };
    //@ts-ignore
    this.dropdownPanelRef = React.createRef();
  }

  componentDidMount(): void {
    document.addEventListener('mousedown', this.handleClickOutside);
    if (this.props.validationFeedbacks && this.props.validationFeedbacks.length) {
      (this.props.validationFeedbacks || []).forEach((validationFeedback: any) => validationFeedback.isRepliesExpanded = false);
      this.expandAllReplies();
    }
  }
  componentWillUnmount(): void {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = (event: any) => {
    if (this.dropdownPanelRef && this.dropdownPanelRef.current && !this.dropdownPanelRef.current.contains(event.target)) {
      this.setState({isFilterOpen: false});
    }
  }

  createNewValidationFeedback = (section: string, feedbackIndex: number = -1, contentId?: string, replyIndex?: number) => {
    const { createNewValidationFeedback, selectedQuestionRef } = this.props;
    selectedQuestionRef.current && selectedQuestionRef.current(contentId);
    createNewValidationFeedback && createNewValidationFeedback(section, feedbackIndex, {},  replyIndex && replyIndex.toString());
  };

  handleStatusTypeSelection(event: any, key: string) {
    const { selectedFeedbackFilters } = this.state;
    if (event.target.checked) {
      selectedFeedbackFilters.push(key);
    } else {
      const index = selectedFeedbackFilters.indexOf(key);
      if (index !== -1) {
        selectedFeedbackFilters.splice(index, 1);
      }
    }
    this.setState({ selectedFeedbackFilters });
  }

  onRejectionReasonModalClose = () => {
    this.setState({ isViewRejectionReasonOpen: false });
  }

  openViewRejectionReason = (rejectionHistory: any) => {
    let rejectionReasonsToShow: any[] = [];
    rejectionHistory.forEach((rejectionEntry: any) => {
      rejectionReasonsToShow.push({
        rejectionComment: rejectionEntry.validatorAction.rejectionComment || '',
        rejectionReasons: rejectionEntry.validatorAction.rejectionReasons || [],
        dateofComment: dateService.dateOnly(rejectionEntry.date),
        user: rejectionEntry.user,
      })
    });
    if (this.props.fromContentCreate) { 
      rejectionReasonsToShow = rejectionReasonsToShow.filter(reason =>
        getPropertyValue(reason, 'user.id', NaN) === getPropertyValue(rejectionReasonsToShow[rejectionReasonsToShow.length - 1], 'user.id', NaN)
      );
    }
    
    this.setState({
      isViewRejectionReasonOpen: true,
      rejectionReasonsToShow,
    });
  } 

  expandAllReplies = () => {
    let { isAllRepliesExpanded } = this.state;
    isAllRepliesExpanded = !isAllRepliesExpanded;
    (this.props.validationFeedbacks || []).forEach((feedback: any) => feedback.isRepliesExpanded = !!isAllRepliesExpanded);
    this.setState({ isAllRepliesExpanded });
  }

  onShowHideReply = (feedback: any) => {
    feedback.isRepliesExpanded = !feedback.isRepliesExpanded;
    const isAllRepliesExpanded = this.props.validationFeedbacks.every((feedback: any) => feedback.isRepliesExpanded);
    this.setState({ isAllRepliesExpanded });
  }

  render() {
    const { classes, validationFeedbacks, allowFeedbacks,contentType, validationEditHistory,fromContentCreate } = this.props;
    const {isFilterOpen, selectedFeedbackFilters, isViewRejectionReasonOpen, rejectionReasonsToShow, isAllRepliesExpanded } = this.state;
    const rejectionHistory = (validationEditHistory || []).filter((history: any) => ((history.validatorAction || {}).rejectionReasons || []).length);
    let totalReasonOfRejection;
    if (fromContentCreate) {
      totalReasonOfRejection = rejectionHistory.reduce((acc: any, reason: any) => {
        if (getPropertyValue(reason, 'user.id', NaN) === getPropertyValue(rejectionHistory[rejectionHistory.length - 1], 'user.id', NaN)) {
          acc += ((reason.validatorAction || {}).rejectionReasons || []).length
        }
        return acc;
      }, 0);
    } else {
      totalReasonOfRejection = rejectionHistory.reduce((acc: any, reason: any) => ((reason.validatorAction || {}).rejectionReasons || []).length + acc, 0);
    }
    const totalNoOfReplies = (validationFeedbacks).reduce((acc: any, feedback: any) => Math.max(((feedback || {}).actions || []).length -1, 0) + acc , 0);
    return (
      <Grid className={classes.feedbackSection}>
          <div className={classes.filterWrapper}>
            <div className={classes.feedbackContainer}>
                <span>{ validationFeedbacks.length } Feedback, {totalNoOfReplies} { totalNoOfReplies !== 1 ? <>Replies</> : <>Reply</>} </span>
                { !!validationFeedbacks.length && !!totalNoOfReplies && <div onClick={this.expandAllReplies} className={classes.collapseAllbtn}>{ isAllRepliesExpanded ? FEEDBACK_STATUS_TEXTS.collapseAll : FEEDBACK_STATUS_TEXTS.expandAll }</div> } 
            </div>
            <div ref={this.dropdownPanelRef}>
              <button className={classes.filterButton} onClick={() => { this.setState({ isFilterOpen: !isFilterOpen }) }}><img src="/assets/svg/contentValidation/filter-icon.svg" alt='Filter' />Filter</button>
              {isFilterOpen &&
                <div className='filterPanel'>
                {Object.values(FEEDBACK_STATUS).map((key: string, index: number) => (
                  <FormControlLabel
                    key={index}
                    control={
                      <Checkbox
                        classes={{
                          root: classes.checkBoxElement,
                          checked: classes.checkedCheckbox,
                          colorPrimary: classes.primaryColor
                        }}
                        checked={selectedFeedbackFilters.includes(key)}
                        onChange={(event: any) => this.handleStatusTypeSelection(event, key)} />}
                    label={titleCase(key)}
                    classes={{ label: classes.checkboxLabel, root: classes.formControlLabel }} />
                ))}
                </div>
              }
            </div>
          </div>
          <div className='feedbackContent'>
            {(rejectionHistory && !!totalReasonOfRejection) && 
              <div className={classes.rejectionReasonsSection}>
                <div className="icon-container">
                  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.99935 1.66699C6.64785 1.66699 5.32669 2.06776 4.20296 2.81862C3.07922 3.56947 2.20337 4.63669 1.68618 5.88532C1.16898 7.13395 1.03365 8.50791 1.29732 9.83344C1.56098 11.159 2.2118 12.3766 3.16746 13.3322C4.12311 14.2879 5.3407 14.9387 6.66623 15.2024C7.99177 15.466 9.36573 15.3307 10.6144 14.8135C11.863 14.2963 12.9302 13.4205 13.6811 12.2967C14.4319 11.173 14.8327 9.85183 14.8327 8.50033C14.8309 6.68855 14.1104 4.95149 12.8293 3.67038C11.5482 2.38926 9.81112 1.66876 7.99935 1.66699ZM7.92602 12.867C7.74921 12.867 7.57964 12.7968 7.45461 12.6717C7.32959 12.5467 7.25935 12.3771 7.25935 12.2003C7.25935 12.0235 7.32959 11.8539 7.45461 11.7289C7.57964 11.6039 7.74921 11.5337 7.92602 11.5337C8.10283 11.5337 8.2724 11.6039 8.39742 11.7289C8.52245 11.8539 8.59269 12.0235 8.59269 12.2003C8.59269 12.3771 8.52245 12.5467 8.39742 12.6717C8.2724 12.7968 8.10283 12.867 7.92602 12.867ZM10.4727 7.98699C10.3357 8.30477 10.1339 8.59046 9.88023 8.82579C9.62653 9.06112 9.32651 9.24091 8.99935 9.35366C8.89023 9.40127 8.79585 9.47723 8.72602 9.57366C8.64813 9.67752 8.60602 9.80384 8.60602 9.93366V10.407C8.60602 10.5838 8.53578 10.7534 8.41076 10.8784C8.28573 11.0034 8.11616 11.0737 7.93935 11.0737C7.76254 11.0737 7.59297 11.0034 7.46795 10.8784C7.34292 10.7534 7.27269 10.5838 7.27269 10.407V9.91366C7.27587 9.5134 7.40407 9.12414 7.63935 8.80032C7.87113 8.49263 8.18898 8.26062 8.55268 8.13366C8.71057 8.08321 8.85442 7.99644 8.97268 7.88032C9.09009 7.77485 9.18311 7.64507 9.24528 7.50001C9.30745 7.35495 9.33728 7.19808 9.33268 7.04033C9.33064 6.8811 9.29425 6.7242 9.22602 6.58033C9.1262 6.39672 8.98461 6.23915 8.81269 6.12033C8.63733 5.99334 8.43368 5.91097 8.21935 5.88032C7.89339 5.81832 7.55608 5.86517 7.25935 6.01366C6.96981 6.15645 6.73548 6.39079 6.59269 6.68033C6.51931 6.84122 6.38502 6.96638 6.21936 7.02827C6.05371 7.09016 5.87025 7.0837 5.70935 7.01033C5.54845 6.93695 5.42329 6.80266 5.36141 6.637C5.29952 6.47135 5.30597 6.28789 5.37935 6.12699C5.63683 5.56196 6.07607 5.09939 6.62703 4.81303C7.17799 4.52668 7.80897 4.43302 8.41935 4.54699C8.83289 4.61044 9.2257 4.77031 9.56602 5.01366C9.91459 5.26183 10.2 5.58837 10.3994 5.96699C10.5523 6.28264 10.6362 6.62728 10.6454 6.9779C10.6546 7.32853 10.5889 7.67709 10.4527 8.00033L10.4727 7.98699Z" fill="#1D7DEA"/>
                  </svg>
                  <span className='title'> Reasons for Rejection</span>
                </div>
                <span className='view-btn' onClick={() => this.openViewRejectionReason(rejectionHistory)}>view</span>
              </div>
            }
            {
              !validationFeedbacks.length
              ? 
              <div className='feedbackEmpty'>
                <p>Please add atleast 1 feedback to reject this {titleCase(contentType)} </p>
                <button className='btnAddFeedback' onClick={()=>this.createNewValidationFeedback(SECTIONS.CONTENT)}>Add Feedback</button>
              </div>
              :
              <div className='feedbackListing'>
                <ul>
                  {
                    validationFeedbacks.map((feedback: any, index: number) => {
                      const lastIndex = feedback.actions.length - 1;
                      let lastAction = getPropertyValue(feedback.actions[lastIndex], 'validatorAction') || getPropertyValue(feedback.actions[lastIndex], 'authorAction', '');
                      lastAction = lastAction === FEEDBACK_VALIDATOR_ACTIONS.REJECTED ? FEEDBACK_VALIDATOR_ACTIONS.OPEN : lastAction;
                      const isNoDataAvailableWithAppliedFilter = validationFeedbacks.every((feedback: any) => !selectedFeedbackFilters.includes(feedback.status));
                      if (isNoDataAvailableWithAppliedFilter) {
                        return (
                          <div className='feedbackEmptyFilters'>
                              <div className="icon-container">
                                <img src="/assets/svg/no-filter-feedback.svg" alt="no feedback icon"/>
                              </div>
                              <h4>No Feedback Found!</h4>
                              <p>We could not find any feedback that matches
                                with your selected filters.
                              </p>
                          </div>
                        )
                      }
                      return (
                      <li key={index}>
                        <div className={cx(classes.header, (feedback.isRepliesExpanded && classes.headerPaddingBottom))} >
                          <span className='counter'>{index + 1}</span>
                          <div className='contentBox'>
                                <h6 onClick={() => this.createNewValidationFeedback(feedback.section, index, feedback.contentId)}>{feedback.actions.find((action: any) => action.comment).comment}</h6>
                                <p>
                                  { feedback.actions.find((a: any) => a.comment).date !== NEW_FEEDBACK_TIME_TO_SHOW ? dateService.getTimeStamp(feedback.actions.find((a: any) => a.comment).date) : NEW_FEEDBACK_TIME_TO_SHOW}
                                  {((feedback.actions || []).length > 1) && (!feedback.isRepliesExpanded ?
                                    <>
                                      <em className={classes.seperator}></em>
                                      <span onClick={(ev) => {ev.nativeEvent.stopImmediatePropagation(); this.onShowHideReply(feedback); }}> {feedback.actions.length - 1} {feedback.actions.length < 3 ? <>Reply</> : <>Replies</>}</span>
                                    </> :
                                    <>
                                      <em className={classes.seperator}></em>
                                      <span onClick={(ev) => {ev.nativeEvent.stopImmediatePropagation(); this.onShowHideReply(feedback)}} className='hideReplylabel'>
                                        Hide {(feedback.actions || []).length < 3 ? <> Reply </> : <> Replies </>} 
                                      </span>
                                    </>)
                                  }
                                </p>
                          </div>
                          <span className={`statusBtn ${lastAction.toLowerCase()}`}>{lastAction}</span>
                        </div>
                        { !!feedback.isRepliesExpanded && (feedback.actions || []).length > 1 &&
                          <div className={classes.repliesSection}>
                              { feedback.actions && feedback.actions.map((action: any, replyIndex: number) => {
                                return (
                                  replyIndex > 0 && <div className={classes.replyContainer} onClick={() => this.createNewValidationFeedback(feedback.section, index, feedback.contentId, replyIndex)}>
                                    <span className={cx('user-name' + (action.authorAction ? ' authors' : ' validators'))}>{ action.authorAction ? FEEDBACK_STATUS_TEXTS.authorInitial : FEEDBACK_STATUS_TEXTS.validatorInitial }</span>
                                    <div className='reply-container-inner'>
                                      <p>
                                        {action.authorAction ? FEEDBACK_STATUS_TEXTS.authorReplied : FEEDBACK_STATUS_TEXTS.userReplied }
                                        <span className='seperator'></span>
                                        {action.date !== NEW_FEEDBACK_TIME_TO_SHOW ? dateService.getTimeStamp(action.date) : action.date }
                                      </p>
                                      <b>{ action.comment }</b> 
                                    </div>
                                 </div> 
                                );
                              })}
                          </div>
                        }
                      </li>
                    )})
                  }
                </ul>
                {
                  allowFeedbacks && (
                    <div className='addFeedbackButton'>
                      <button className='addfeedbackBtn' onClick={()=>this.createNewValidationFeedback(SECTIONS.CONTENT)}>Add Feedback</button>
                    </div>
                  )
                }
              </div>
            }
          </div>
          <ViewRejectionReasonModal isModalOpen={isViewRejectionReasonOpen} onModalClose={this.onRejectionReasonModalClose.bind(this)} rejectionReasonData={rejectionReasonsToShow}/>
        </Grid>
    );
  }
}

// @ts-ignore
export default withStyles(styles)(FeedbackSidebar);
